import ButtonUpdatePassword from './ButtonUpdatePassword';
export default ButtonUpdatePassword;
